"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiGateway = void 0;
const axios_1 = __importDefault(require("axios"));
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const axios_cache_adapter_1 = require("axios-cache-adapter");
class ApiGateway {
    constructor(config) {
        const cache = axios_cache_adapter_1.setupCache({
            maxAge: config.cacheAge,
        });
        this.defaultConfig = {
            baseURL: config.baseUrl,
            headers: {
                'Content-Type': 'application/json',
            },
            adapter: cache.adapter,
            responseType: 'json',
        };
        this.api = axios_1.default.create(this.defaultConfig);
    }
    depositAddress(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.api.post(`/v1alpha/polkadot/depositAddress`, request);
            return data;
        });
    }
    deposit(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.api.post(`/v1alpha/polkadot/deposit`, request);
            return data;
        });
    }
    getBalance(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParams = Object.entries(request)
                .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
                .join('&');
            const { data: { total, claimable } } = yield this.api.get(`/v1alpha/polkadot/balance?${queryParams}`);
            return {
                total: new bignumber_js_1.default(total),
                claimable: new bignumber_js_1.default(claimable),
            };
        });
    }
    getHistory(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParams = Object.entries(request)
                .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
                .join('&');
            const { data } = yield this.api.get(`/v1alpha/polkadot/history?${queryParams}`);
            return data.map(({ address, timestamp, type, amount, status, id }) => {
                return {
                    address,
                    timestamp,
                    type,
                    amount: new bignumber_js_1.default(amount),
                    status,
                    id,
                };
            });
        });
    }
    claim(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { claim, tokenAddress } } = yield this.api.post(`/v1alpha/polkadot/claim`, request);
            return {
                claim: {
                    address: claim.address,
                    status: claim.status,
                    data: {
                        network: claim.data.network,
                        claimId: claim.data.claimId,
                        issueBlock: Number(claim.data.issueBlock),
                        claimBeforeBlock: Number(claim.data.claimBeforeBlock),
                        amount: new bignumber_js_1.default(claim.data.amount),
                        signature: claim.signature,
                    },
                    createdTimestamp: claim.createdTimestamp,
                    expiresTimestamp: claim.expiresTimestamp,
                },
                tokenAddress,
            };
        });
    }
    getCrowdloanById(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { crowdloans } } = yield this.api.get(`/v1alpha/polkadot/crowdloans`, {
                params: request,
            });
            if (crowdloans.length !== 1) {
                throw new Error(`Unable to resolve crowdloan by id ${request.loanId} for network ${request.network}`);
            }
            return this.mapCrowdloanData(crowdloans[0]);
        });
    }
    mapCrowdloanData(d) {
        const parseBigOrZero = (value) => {
            try {
                return new bignumber_js_1.default(`${value}`, 10);
            }
            catch (e) {
                return new bignumber_js_1.default('0');
            }
        };
        const parseNumberOrZero = (value) => {
            let result = Number.parseInt(`${value}`, 10);
            if (Number.isNaN(result)) {
                result = 0;
            }
            return result;
        };
        return {
            airdropPool: d.airdropPool,
            airdropRate: parseBigOrZero(d.airdropRate),
            airdropScheme: d.airdropScheme,
            alreadyContributed: parseBigOrZero(d.alreadyContributed),
            bondTokenContract: d.bondTokenContract,
            bondTokenName: d.bondTokenName,
            bondTokenSymbol: d.bondTokenSymbol,
            currentBid: parseBigOrZero(d.currentBid),
            currentRate: parseBigOrZero(d.currentRate),
            endLease: parseNumberOrZero(d.endLease),
            endTime: parseNumberOrZero(d.endTime),
            fallbackRate: parseBigOrZero(d.fallbackRate),
            loanId: parseNumberOrZero(d.loanId),
            parachainUrl: d.parachainUrl,
            projectDescription: d.projectDescription,
            projectLogo: d.projectLogo,
            projectName: d.projectName,
            projectUrl: d.projectUrl,
            rewardPool: d.rewardPool,
            rewardRate: parseBigOrZero(d.rewardRate),
            rewardRateTicker: d.rewardRateTicker,
            rewardScheme: d.rewardScheme,
            rewardTokenContract: d.rewardTokenContract,
            rewardTokenName: d.rewardTokenName,
            rewardTokenSymbol: d.rewardTokenSymbol,
            stakeFiContributed: parseBigOrZero(d.stakeFiContributed),
            startLease: parseNumberOrZero(d.startLease),
            startTime: parseNumberOrZero(d.startTime),
            status: d.status,
            totalRaiseTarget: parseBigOrZero(d.totalRaiseTarget),
        };
    }
    getCrowdloans(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { crowdloans } } = yield this.api.get(`/v1alpha/polkadot/crowdloans`, {
                params: request,
            });
            return crowdloans.map(this.mapCrowdloanData);
        });
    }
    crowdloanDepositAddress(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.api.post(`/v1alpha/polkadot/crowdloanDepositAddress`, request);
            return data;
        });
    }
    getCrowdloanBalances(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { balances } } = yield this.api.get(`/v1alpha/polkadot/crowdloanBalance`, {
                params: request
            });
            return {
                balances: balances.map((b) => {
                    return {
                        total: new bignumber_js_1.default(b.total),
                        claimable: new bignumber_js_1.default(b.claimable),
                        loanId: Number(b.loanId),
                    };
                })
            };
        });
    }
    getCrowdloanHistory(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParams = Object.entries(request)
                .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
                .join('&');
            const { data } = yield this.api.get(`/v1alpha/polkadot/crowdloanHistory?${queryParams}`);
            return data.map((d) => {
                const { address, timestamp, type, amount, status, id } = d;
                return {
                    address,
                    timestamp,
                    type,
                    amount: new bignumber_js_1.default(amount),
                    status,
                    id,
                };
            });
        });
    }
    crowdloanClaim(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { claim, tokenAddress } } = yield this.api.post(`/v1alpha/polkadot/crowdloanClaim`, Object.assign({}, request, {
                amount: request.amount.toString(10),
            }));
            return {
                claim: {
                    address: claim.address,
                    status: claim.status,
                    data: {
                        network: claim.data.network,
                        claimId: claim.data.claimId,
                        issueBlock: claim.data.issueBlock,
                        claimBeforeBlock: claim.data.claimBeforeBlock,
                        amount: new bignumber_js_1.default(claim.data.amount),
                        signature: claim.data.signature,
                    },
                    createdTimestamp: claim.createdTimestamp,
                    expiresTimestamp: claim.expiresTimestamp,
                },
                tokenAddress,
            };
        });
    }
}
exports.ApiGateway = ApiGateway;
//# sourceMappingURL=gateway.js.map